// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"j4-z"};